// extracted by mini-css-extract-plugin
module.exports = {"kitG":"kitG_kitG__AALY5"};